
import KyberNetwork from "../../../assets/filled/KyberNetwork.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KyberNetworkIcon({ className, dataTestid = "KyberNetworkIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <KyberNetwork data-testid={dataTestid} className={classes} {...rest} />
  );
}
